import Image from 'next/legacy/image';
import { crashPng } from '../../generated/images';
import { useTranslation } from '../../lib/i18n';
import { Container } from '../layout/container';
import Layout from '../layout/layout';
import { Button } from './button';

const NotFound = ({ preview }) => {
  const { t } = useTranslation();
  return (
    <Layout preview={preview} robots='noindex'>
      <Container className='text-center'>
        <h1 className='my-10'>{t('pageNotFound')}</h1>
        <div>
          <Image {...crashPng} alt='' />
        </div>
        <Button className='mt-4' href='/'>
          {t('backToHome')}
        </Button>
      </Container>
    </Layout>
  );
};

export default NotFound;
